import { createUseMutationHook } from 'hooks/createUseMutationHook';

export const useApprove = createUseMutationHook(
    'person_trip_approve',
    tripId => [
        ['trip_detail', tripId],
        ['person_trip_detail', tripId],
    ],
);
